module.exports = __webpack_public_path__ + "0651be2c5d57ad46ecba583c7e1d4ded.png";